import { makeStyles } from '@mui/styles';
import InputAdornment from 'apollo-react/components/InputAdornment';
import React from 'react';

const useStyles = makeStyles({
  inputIcon: {
    maxHeight: 'none',
    margin: '0 10px !important',
    border: 'none !important',
    color: '#b5b5b5 !important',
  },
});

const InputIcon = (props) => {
  const classes = useStyles();

  return <InputAdornment className={classes.inputIcon} {...props} />;
};

export default InputIcon;
